import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconProject16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2 3.667h5.6c.294 0 .533.239.533.533v5.6a.533.533 0 01-.533.533H4.2a.533.533 0 01-.533-.533V4.2c0-.294.238-.533.533-.533zm2.633 7.666H4.2A1.533 1.533 0 012.667 9.8V4.2c0-.847.686-1.533 1.533-1.533h5.6c.847 0 1.533.686 1.533 1.533v2.633h.467c1.123 0 2.033.91 2.033 2.034V11.8c0 1.123-.91 2.033-2.033 2.033H8.867A2.033 2.033 0 016.833 11.8v-.467zm1 0v.467c0 .57.463 1.033 1.034 1.033H11.8c.57 0 1.033-.462 1.033-1.033V8.867c0-.571-.462-1.034-1.033-1.034h-.467V9.8c0 .847-.686 1.533-1.533 1.533H7.833z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 5.532a.53.53 0 01.789-.465l2.65 1.469a.53.53 0 010 .928l-2.65 1.469a.53.53 0 01-.789-.465V5.532z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconProject16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;